import { Outlet } from '@tanstack/react-router';

import { AppHeader } from '@/router/components/AppHeader';

export function EntryBaseLayout() {
  return (
    <div className="min-h-dvh overflow-x-clip bg-[linear-gradient(180deg,var(--color-marigold-300)_0%,var(--color-jasmine-100)_58%)]">
      <AppHeader withShadow={false} />
      <main className="mx-auto max-w-none">
        <div className="mx-3 mb-8 sm:mx-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
